import Navbar from "@/components/home/Navbar";
import HeroSection from "@/components/home/HeroSection";
import AboutSection from "@/components/home/AboutSection";
import PromoVideoSection from "@/components/home/PromoVideoSection";
import PhoneMockupSection from "@/components/home/PhoneMockupSection";
import InvestmentPlanSection from "@/components/home/InvestmentPlanSection";
import WhyChooseSection from "@/components/home/WhyChooseSection";
import HowItWorksSection from "@/components/home/HowItWorksSection";
import CompanyStatsSection from "@/components/home/CompanyStatsSection";
import WithdrawalTicker from "@/components/home/WithdrawalTicker";
import SecuritySection from "@/components/home/SecuritySection";
import TestimonialsSection from "@/components/home/TestimonialsSection";
import PartnersSection from "@/components/home/PartnersSection";
import RegulatorySection from "@/components/home/RegulatorySection";
import Footer from "@/components/home/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <PromoVideoSection />
        <PhoneMockupSection />
        <InvestmentPlanSection />
        <WhyChooseSection />
        <HowItWorksSection />
        <CompanyStatsSection />
        <WithdrawalTicker />
        <SecuritySection />
        <TestimonialsSection />
        <PartnersSection />
        <RegulatorySection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
